<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { showConfirm } from '@/utils'

const refreshIcon = new URL('../assets/imgs/refresh-icon.png', import.meta.url).href
const closeIcon = new URL('../assets/imgs/close-icon.png', import.meta.url).href

const authStore = useAuthStore()
const router = useRouter()

function refreshPage() {
  window.location.reload()
}

async function onCloseClick() {
  try {
    await showConfirm('温馨提示', '您确定退出当前页面吗？', {
      closeOnClickOverlay: true,
    })
    await router.replace({ path: '/' })

    if (window.postMessage) {
      window.postMessage('close_lucky_window', '*')
    }
  } catch {
    // 取消或关闭遮罩
  }
}
</script>

<template>
  <div
    v-if="authStore.isMerMember"
    class="mer-member-floating-bar pointer-events-auto fixed z-1000 flex items-stretch overflow-hidden rounded-full"
    :style="{
      top: 'calc(env(safe-area-inset-top, 0px) + 6px)',
      right: 'calc(env(safe-area-inset-right, 0px) + 6px)',
    }"
    role="toolbar"
    aria-label="商户快捷操作"
  >
    <button
      type="button"
      class="flex h-9 min-w-[44px] flex-1 items-center justify-center px-3 active:bg-white/10"
      aria-label="刷新页面"
      @click="refreshPage"
    >
      <img :src="refreshIcon" alt="" class="size-5 object-contain" />
    </button>
    <span class="my-2.5 w-px shrink-0 self-stretch bg-white/70" aria-hidden="true" />
    <button
      type="button"
      class="flex h-9 min-w-[44px] flex-1 items-center justify-center px-3 active:bg-white/10"
      aria-label="关闭并返回首页"
      @click="onCloseClick"
    >
      <img :src="closeIcon" alt="" class="size-5 object-contain" />
    </button>
  </div>
</template>

<style scoped>
.mer-member-floating-bar {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
